import account from './icon_account.svg'
import addMenuArcheive from './icon_addMenuArcheive.svg'
import addMenuItem from './icon_addMenuItem.svg'
import backButton from './icon_backButton.svg'
import bigCheckInIcon from './icon_bigCheckInIcon.svg'
import checkIn from './icon_checkIn.svg'
import checkOutCheckInIcon from './icon_checkOutCheckInIcon.svg'
import checkOutCheckInIconUnChecked from './icon_checkOutCheckInIconUnChecked.svg'
import dashboard from './icon_dashboard.svg'
import hamburger from './icon_hamburger.svg'
import invoices from './icon_invoices.svg'
import onboarding from './icon_onboarding.svg'
import paymentOption from './icon_paymentOptions.svg'
import peopleMinus from './icon_peopleMinus.svg'
import peoplePlus from './icon_peoplePlus.svg'
import priceModel from './icon_priceModel.svg'
import profile from './icon_profile.svg'
import seating from './icon_seating.svg'
import seatingSelected from './icon_seatingSelected.svg'
import smallCheckInIcon from './icon_smallCheckInIcon.svg'
import upcoming from './icon_upcoming.svg'
import upcomingMenus from './icon_upcomingMenus.svg'
import optionTimes from './icon_optionsTimes.svg'
import booking_list from './icon_booking_list.svg'


export const icon_account = account;
export const icon_addMenuArcheive = addMenuArcheive;
export const icon_addMenuItem = addMenuItem;
export const icon_backButton = backButton;
export const icon_bigCheckInIcon = bigCheckInIcon;
export const icon_booking_list = booking_list;
export const icon_checkIn= checkIn;
export const icon_checkOutCheckInIcon= checkOutCheckInIcon;
export const icon_checkOutCheckInIconUnChecked = checkOutCheckInIconUnChecked;
export const icon_dashboard = dashboard;
export const icon_hamburger = hamburger;
export const icon_invoices = invoices;
export const icon_onboarding = onboarding;
export const icon_paymentOption = paymentOption;
export const icon_peopleMinus = peopleMinus;
export const icon_peoplePlus = peoplePlus;
export const icon_priceModel = priceModel;
export const icon_profile = profile;
export const icon_seating = seating;
export const icon_seatingSelected = seatingSelected;
export const icon_smallCheckInIcon = smallCheckInIcon;
export const icon_upcoming = upcoming;
export const icon_upcomingMenus = upcomingMenus;
export const icon_optionTimes = optionTimes;